import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";

import { useMe } from "./api";

/** 未登录或会话过期 → 回到登录页，登录后再回到原来的页面。 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) {
    return (
      <Box sx={{ position: "fixed", inset: 0 }}>
        <LinearProgress />
      </Box>
    );
  }
  if (!me.data) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  return children;
}
